export default {
  list: [],
  applicationsList: [],
  pendingEditRequestsList: []
}
